import { apiHubBaseUrl, request } from '@/libs/api-request'

export function getBasicInfo (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/common/get_basic_info'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getTopRefer (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/common/get_top_refer'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getAiReferer (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/common/get_ai_referer'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getTopReferDashboard (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/common/get_top_refer_dashboard'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getData (params, force, cancelToken) {
  let url = apiHubBaseUrl() + '/v1/journeymap/journey/get_data'

  const config = {
    method: 'post',
    url,
    data: params,
    cancelToken: cancelToken
  }

  return request(config, force)
}

export function getPluckData (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/journey/get_data'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getReferMap (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/journey/get_rollback_refers'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getUtmParameter (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/common/get_utm'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getIncludeUrls (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/journey/get_node_urls'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getTargetIncludeUrls (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/target/get_node_urls'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getReliabilityData (params, force = true) {
  const url = apiHubBaseUrl() + '/v1/journeymap/common/get_reliability'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getNodeUsers (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/journey/get_node_users'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getDeviceStatistics (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/common/get_device_statistics'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getVisitStatistics (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/common/get_visit_statistics'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getGeoStatistics (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/common/get_geo_statistics'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
